import { useDispatch, useSelector } from 'react-redux';
import DepositSelectSum from './DepositSelectSum/DepositSelectSum';
import {
  IApplicationState,
  OVERLAY_DEPOSIT_KEYBOARD_SET_COUNT,
  OVERLAY_DEPOSIT_KEYBOARD_SHOW,
  OVERLAY_PAYNPLAY_REGISTER_SHOW,
} from '@spinwise/spinwise-core';
import { useEffect, useState } from 'react';
import { currencyToAmount } from 'Utils/index';
import { t } from 'i18next';
import DepositSelectSumC from './DepositSelectSumC/DepositSelectSumC';
import DepositSelectSumSport from './DepositSelectSumSport/DepositSelectSumSport';

interface IDepositSelectSumManager {
  viewVersion: 'A' | 'C' | 'sport';
}

/** @todo
 *
 * After deciding about useful or useless interfaces (After 10.2025)
 * Please remove the interface and add inline type or keep as is.
 *
 */
const DepositSelectSumManager = ({ viewVersion = 'A' }: IDepositSelectSumManager) => {
  const dispatch = useDispatch();
  const show = useSelector((state: IApplicationState) => state.overlayReducer?.paynplayRegister?.show);
  const defaultAmount = useSelector(
    (state: IApplicationState) => state.overlayReducer?.paynplayRegister?.defaultAmount,
  );
  const amount = useSelector((state: IApplicationState) => state.overlayReducer?.paynplayRegister?.amount);
  const max_amount_from =
    useSelector((state: IApplicationState) => state.paynplayReducer?.paynplayLimit?.max_amount_from) || 10000;
  const min_amount_to =
    useSelector((state: IApplicationState) => state.paynplayReducer?.paynplayLimit?.min_amount_to) || 20;
  const code = useSelector((state: IApplicationState) => state.globalReducer.geo.code);
  const reg_type = useSelector((state: IApplicationState) => state.globalReducer.geo.reg_type);
  const preselectedAmountsKey =
    viewVersion === 'sport'
      ? 'sport.preselected.amounts'
      : code === 'EST'
      ? 'est.preselected.amounts'
      : 'preselected.amounts';
  const sumArray = t(preselectedAmountsKey)?.split(',');

  const [landingVersion, setLandingVersion] = useState(null);

  useEffect(() => {
    if (localStorage?.getItem('landing-version') !== null) {
      setLandingVersion(localStorage?.getItem('landing-version'));
    }
  }, []);

  const [selectedValue, setSelectedValue] = useState(sumArray[0] ?? 50);

  useEffect(() => {
    dispatch({
      type: OVERLAY_PAYNPLAY_REGISTER_SHOW,
      data: {
        defaultAmount: currencyToAmount(selectedValue),
        amount: currencyToAmount(selectedValue),
      },
    });
  }, [selectedValue]);

  useEffect(() => {
    if (show == false) {
      onAmountSelected(amount?.toString() ?? '');
    }
  }, [amount]);

  useEffect(() => {
    setSelectedValue(defaultAmount?.toString() ?? null);
  }, [defaultAmount]);

  useEffect(() => {
    dispatch({
      type: OVERLAY_DEPOSIT_KEYBOARD_SET_COUNT,
      data: {
        selectedValue: currencyToAmount(selectedValue),
        suggestedValues: [100, 200, 500],
      },
    });
  }, [selectedValue]);

  const onAmountSelected = (amount: string) => {
    if (!max_amount_from) {
      setSelectedValue(amount);
      return;
    }

    setSelectedValue(parseFloat(amount) > max_amount_from ? max_amount_from : amount);
  };

  const getTypeLabel = (labelTemp?: string, isPnp?: boolean) => {
    let label = isPnp ? 'pnp' : reg_type ?? 'paynplay_t';
    return t(`${label}.${labelTemp}`);
  };

  const onButtonClick = () => {
    dispatch({
      type: OVERLAY_PAYNPLAY_REGISTER_SHOW,
      data: {
        show: true,
      },
    });
  };

  const overlayDepositKeyboardShow = () => {
    dispatch({
      type: OVERLAY_DEPOSIT_KEYBOARD_SHOW,
      data: true,
    });
  };

  return (
    <>
      {viewVersion == 'A' && (
        <DepositSelectSum
          MIN_DEP_AMOUNT={min_amount_to}
          selectedValue={selectedValue}
          sumArray={sumArray.slice(1, 4)}
          typeLabel={getTypeLabel('sum.select.btn.label')}
          setSelectedValue={setSelectedValue}
          onAmountSelected={onAmountSelected}
          onClickButton={onButtonClick}
          onClickMobileInput={overlayDepositKeyboardShow}
        ></DepositSelectSum>
      )}
      {viewVersion == 'C' && (
        <DepositSelectSumC
          MIN_DEP_AMOUNT={min_amount_to}
          selectedValue={selectedValue}
          sumArray={sumArray.slice(1, 4)}
          typeLabel={
            landingVersion === 'c2' && reg_type !== 'email'
              ? getTypeLabel('sum.select.btn.label.c2.pnp')
              : getTypeLabel('sum.select.btn.label.b')
          }
          setSelectedValue={setSelectedValue}
          onAmountSelected={onAmountSelected}
          onClickButton={onButtonClick}
          onClickMobileInput={overlayDepositKeyboardShow}
        ></DepositSelectSumC>
      )}
      {viewVersion == 'sport' && (
        <DepositSelectSumSport
          MIN_DEP_AMOUNT={min_amount_to}
          selectedValue={selectedValue}
          sumArray={sumArray.slice(1, 4)}
          typeLabel={getTypeLabel('sum.select.btn.label.sport.pnp')}
          setSelectedValue={setSelectedValue}
          onAmountSelected={onAmountSelected}
          onClickButton={onButtonClick}
          onClickMobileInput={overlayDepositKeyboardShow}
        />
      )}
    </>
  );
};

export default DepositSelectSumManager;
